import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  getCategories,
  selectCategories,
} from "../../redux/features/category/CategorySlice";
import {
  createItem,
  // selectItemSuccess,
} from "../../redux/features/item/ItemSlice";
// import { useNavigate } from "react-router-dom";
import { BACKEND_BASEURL } from "../../db/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingSpinner from "../Loader/LoadingSpinner";

const CreateItemForm = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    itemName: "",
    description: "",
    category: "",
    price: 0,
    cost: 0,
    tax: 0,
    barcode: "",
    inventory: 0,
  });
  const [productId, setProductId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const getLastProductId = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BACKEND_BASEURL}api/items/lastProduct`
      );
      setProductId(response.data);
      setLoading(false);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      toast.error(message);
      setProductId(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    getLastProductId();
    // console.log(productId);
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.itemName) newErrors.itemName = "Item name is required.";
    if (!formData.category) newErrors.category = "Item category is required.";
    if (!formData.price) newErrors.price = "Item price is required.";
    if (!formData.inventory)
      newErrors.inventory = "Item inventory is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  // let isSuccess = useSelector(selectItemSuccess);
  // const navigate = useNavigate();

  useImperativeHandle(ref, () => ({
    submitForm: handleSubmit,
  }));

  const categories = useSelector(selectCategories);
  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  const tax_schedule = [0, 5, 16];

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();
    if (validateForm()) {
      console.log("Form Data:", formData);
      const itemData = {
        name: formData.itemName,
        description: formData.description,
        category: formData.category,
        price: formData.price,
        cost: formData.cost,
        tax: formData.tax,
        barcode: formData.barcode,
        inventory: Number(formData.inventory),
        productId: productId.productId + 1,
      };
      await dispatch(createItem(itemData));
    }
  };
  // useEffect(() => {
  //   if (isSuccess) {
  //     navigate("/items");

  //   }
  // }, [isSuccess, navigate]);

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="flex items-center w-full justify-center bg-[#F1F1F1] min-h-screen inner-container">
        <div className="bg-white py-8 md:px-16 px-8 my-16 rounded-lg shadow-md md:w-[75%] w-[85%]">
          <form>
            <p className=" bg-slate-300 w-max py-2 px-4 rounded-full mb-4 ">
              Item ID: {productId?.productId + 1 || ""}
            </p>

            {/* Item Name */}
            <div className="mb-4 flex flex-col items-start">
              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                Item Name
              </label>
              <input
                type="text"
                name="itemName"
                value={formData.itemName}
                onChange={handleInputChange}
                placeholder="Name"
                className="w-full outline-none text-[1rem] rounded-none font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
              />
              {errors.itemName && (
                <span className="text-red-500 text-sm">{errors.itemName}</span>
              )}
            </div>

            {/* Description */}
            <div className="mb-4 flex flex-col items-start">
              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                Description
              </label>
              <input
                type="text"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="Description"
                className="w-full outline-none text-[1rem] rounded-none font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
              />
            </div>

            {/* Category */}
            <div className="mb-4 flex flex-col items-start">
              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                Category
              </label>
              <select
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                className="w-full outline-none text-[1rem] bg-transparent rounded-none font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
              >
                <option value="">Select category</option>
                {categories?.map((category, index) => (
                  <option
                    key={index}
                    value={category.name.toLowerCase()}
                    className="capitalize"
                  >
                    {category.name}
                  </option>
                ))}
              </select>
              {errors.category && (
                <span className="text-red-500 text-sm">{errors.category}</span>
              )}
            </div>

            {/* cost */}
            <div className="mb-4 flex flex-col items-start">
              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                Cost
              </label>
              <div className="flex w-full gap-3">
                <input
                  type="number"
                  min={0}
                  step={0.1}
                  onWheel={(e) => e.target.blur()}
                  name="cost"
                  value={formData.cost}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  className="w-full outline-none text-[1rem] rounded-none font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
              </div>
            </div>

            {/* Price */}
            <div className="mb-4 flex flex-col items-start">
              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                Price
              </label>
              <input
                type="number"
                name="price"
                min={0}
                step={0.1}
                onWheel={(e) => e.target.blur()}
                value={formData.price}
                onChange={handleInputChange}
                placeholder="0.00"
                className="w-full outline-none text-[1rem] rounded-none font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
              />
              {errors.price && (
                <span className="text-red-500 text-sm">{errors.price}</span>
              )}
            </div>

            {/* barcode */}
            <div className="mb-4 flex flex-col items-start mt-2">
              <label className=" text-[.75rem] font-semibold text-[#7D7D7D]">
                Barcode
              </label>
              <input
                type="text"
                name="barcode"
                value={formData.barcode}
                onChange={handleInputChange}
                placeholder="93833920202928"
                className="w-full outline-none text-[1rem] rounded-none font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] "
              />
            </div>

            {/* inventory */}
            <div className="mb-4 flex flex-col items-start mt-2">
              <label className=" text-[.75rem] font-semibold text-[#7D7D7D]">
                Inventory
              </label>
              <input
                type="number"
                name="inventory"
                min={1}
                step={1}
                onWheel={(e) => e.target.blur()}
                value={formData.inventory}
                onChange={handleInputChange}
                placeholder="10,20 etc"
                className="w-full outline-none text-[1rem] rounded-none font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] "
              />
              {errors.inventory && (
                <span className="text-red-500 text-sm">{errors.inventory}</span>
              )}
            </div>

            {/* Category */}
            <div className="mb-4 flex flex-col items-start">
              <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                Tax
              </label>
              <select
                name="tax"
                value={formData.tax}
                onChange={handleInputChange}
                className="w-full outline-none text-[1rem] rounded-none bg-transparent font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C] capitalize"
              >
                {tax_schedule?.map((tax, index) => (
                  <option key={index} value={tax} className="capitalize">
                    {tax}%
                  </option>
                ))}
              </select>
            </div>
          </form>
        </div>
      </div>
    </>
  );
});

export default CreateItemForm;
